// extracted by mini-css-extract-plugin
export default {"navBar":"Menu_navBar__02+4j","home":"Menu_home__enI-O","movies":"Menu_movies__vAnPU"};